import { connect } from 'react-redux'
import LicenseAccessManagement from '../../components/LicenseAccess/LicenseAccessManagement'
import {getAdminInfo, getLicenseAccess, getUserEmails} from "../../actions/index";

const mapStateToProps = state => {
    return {
        userName: state.auth.username,
        isAdmin: state.auth.adminInfo === 1,
        data: state.licenseAccess.allLicenses,
        emails: state.users.emails
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getLicenseAccess : () => {
            return dispatch(getLicenseAccess());
        },
        getUserEmails: () => {
            return dispatch(getUserEmails())
        }



    }

};


export default connect(
    mapStateToProps,
    mapDispatchToProps

)(LicenseAccessManagement);
